import { useAddressStore } from '@features/shipping-methods'
import { useDelivery } from '@features/shipping-methods/hooks/useDelivery'

/**
 * Хук для получения данных о зоне доставки для текущего адреса
 * Использует централизованный useDelivery для получения данных
 */
export function useZonesFromAddress () {
  const { isPickup, zoneId } = useAddressStore()
  
  const {
    deliveryZones,
    currentZone,
    minOrderCost,
    deliveryCost,
    freeSlotDeliveryCostFrom,
    loadingZones,
    isSlotDeliveryAvailable,
    slots,
  } = useDelivery()

  return {
    zones: deliveryZones,
    currentZone,
    zoneId,
    minOrderCost,
    deliveryCost,
    freeSlotDeliveryCostFrom,
    isPickup,
    loading: loadingZones,
    isSlotDeliveryAvailable,
    hasAvailableSlots: slots.length > 0
  }
}
